<template xmlns="http://www.w3.org/1999/html">
  <div class="main-content">
    <div class="title">清除缓存</div>
    <div style="margin: 16px;">
      <van-button type="info" round block @click="onClearCache">点击清除</van-button>
    </div>
     <van-button type="info" round block @click="onOpenChat">打开会话</van-button>
  </div>
</template>

<script>

import {clearCacheData} from "../../utils/base";
import {Toast} from "vant";

export default {
  data() {
    return {

    };
  },
  mounted() {

  },
  methods: {
    onClearCache(){

      clearCacheData();

      if (!localStorage.removeItem("token")) {
        Toast.success('清除缓存成功，请尝试重新访问其它页面');
      } else {
        Toast.success('清除失败，请重试');
      }
    },
    onOpenChat() {

      let params = {
        // 参与会话的企业成员，多个用 ; 分隔
        userIds: 'wuzhenjiang_TP6HB5QG',
        // 参与会话的外部联系人，多个用 ; 分隔
        externalUserIds: 'wmf7WCBgAApnR2SwyBEAbLbpduS1nTZA',
        // 单聊时会话名称传空字符串
        groupName: '',
        // 新建会话，chatId 必须为空字符串
        chatId: '',
        success: function (res) {
          console.log('打开会话成功', res,res.chatId);
          Toast.success('打开会话成功');
        },
        fail: function (res) {
          Toast.fail('打开会话失败：' + res.errMsg);
        }
      };

      if (typeof wx != 'undefined' && wx.openEnterpriseChat) {
        wx.openEnterpriseChat(params);
      } else if (typeof ww != 'undefined' && ww.openEnterpriseChat) {
        ww.openEnterpriseChat(params);
      } else {
        Toast.fail('当前环境不支持打开会话');
      }
      // ww.openEnterpriseChat({
      //   groupName: '',
      //   userIds: [
      //     'wuzhenjiang_TP6HB5QG',
      //   ],
      //   externalUserIds: [
      //     'wmf7WCBgAApnR2SwyBEAbLbpduS1nTZA',
      //   ],
      //   success: function(res) {
		  //     console.log('打开会话成功', res,res.chatId);
      //     Toast.success('打开会话成功'+res);
      //   },
      // })
    },
  },
};
</script>

<style>
.main-content .title{
  font-size: large;
  font-weight: bold;
  margin: 10px auto;
  text-align: center;
}
.main-content .desc {
  color: #7F7F7F;
  line-height: 2em;
}
.main-content .desc .desc-title {
  color: red;
  font-weight: bold;
}
</style>